import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { CustomLoaderService } from '../services/custom-loader.service';
import { LoginService } from '../services/login.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
declare var $: any;
@Component({
  selector: 'app-mpinlogin',
  templateUrl: './mpinlogin.component.html',
  styleUrls: ['./mpinlogin.component.scss']
})
export class MPINLoginComponent implements OnInit {
  Arrayofresp: any[] = [];

  Urldata: any;
  IsOptimoney: boolean = environment.IsOptimoney;
  constructor(
    private EncrdecrService: EncrdecrService,
    private LoginService: LoginService,
    private router: Router,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private Loader: CustomLoaderService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    debugger;
    this.Loader.show();
    this.route.queryParams.subscribe((queryparam) => {
      this.Urldata = queryparam.data;
      console.log('Urldta :' + this.Urldata);
    });
    this.querystring(this.Urldata);
    if (
      this.Urldata != '' &&
      this.Urldata != null &&
      this.Urldata != undefined
    ) {
      debugger;
      let NewClientId = this.Urldata.replaceAll(' ', '+');
      let decrClientId = this.EncrdecrService.getDecr(NewClientId);
      console.log('decrClientId :' + decrClientId);
      if (
        decrClientId != '' &&
        decrClientId != null &&
        decrClientId != undefined
      ) {
        let splitclientid = decrClientId.split('|');
        let TOKEN_ID = splitclientid[0];
        let LOGIN_ID = splitclientid[1];
        let USER_TYPE = splitclientid[2];
        let USER_NAME = splitclientid[3];
        let EMAIL_ID = splitclientid[4];
        let MOBILE = splitclientid[5];
        let USER_ID = splitclientid[6];
        let Family_ID = splitclientid[7];
        let FIFO = splitclientid[8];
        let DOE = splitclientid[9];
        let SWPFlag = splitclientid[10];
        let STPFlag = splitclientid[11];
        let SwitchFlag = splitclientid[12];
        let RedeemFlag = splitclientid[13];
        let SubBrokerCode = splitclientid[14];
        let RazorCustId = splitclientid[15];
        let Companylogobase64 = splitclientid[16];
        let RazorePaymentStatus = splitclientid[17];
        let SubbrokerName = splitclientid[18];
        let SubbrokerMb = splitclientid[19];
        let Cobranding = splitclientid[20];
        let Exchange = splitclientid[21];
        let RelationShipId = splitclientid[22];
        // let LoginFlag : string = "";
        // if (splitclientid.length > 13) {
        //   LoginFlag = splitclientid[13];
        // }

        debugger;
        // console.log(res);
        if (this.IsOptimoney || environment.CompayName == 'IFA') {
          if (FIFO != 'Y') {
            if (DOE == 'N') {
              this.Loader.hide(); //added by adarsh 03052023
              this.CallAlertModal('Access denied !!');
              if (USER_TYPE == '2') {
                this.router.navigateByUrl('/login');
              } else {
                this.router.navigateByUrl('/login/investor');
              }
              // window.location.reload();
              //this.router.navigateByUrl('');
              return;
            }
          } else {
            this.Loader.hide(); //added by adarsh 03052023
            this.CallAlertModal(
              'Access denied! Portfolio refresh and other mainteinance activity in progress. Please check after 30-60 minutes.'
            );
            if (USER_TYPE == '2') {
              this.router.navigateByUrl('/login');
            } else {
              this.router.navigateByUrl('/login/investor');
            }
            // window.location.reload();
            return;
          }
        }
        if (USER_TYPE == '3') {
          sessionStorage.setItem(
            '@SWPFLAG',
            this.EncrdecrService.setEncr(SWPFlag)
          ); //SWPFlag
          sessionStorage.setItem(
            '@STPFLAG',
            this.EncrdecrService.setEncr(STPFlag)
          ); //STPFlag
          sessionStorage.setItem(
            '@SwitchFlag',
            this.EncrdecrService.setEncr(SwitchFlag)
          ); //SwitchFlag
          sessionStorage.setItem(
            '@RedeemFlag',
            this.EncrdecrService.setEncr(RedeemFlag)
          ); //RedeemFlag
        }
        sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', TOKEN_ID);
        sessionStorage.setItem(
          'F44sGAGh2xwkpUL',
          this.EncrdecrService.setEncr(LOGIN_ID)
        ); //Session_SubBrokerId
        sessionStorage.setItem(
          'V4WGROuLLBE6t98',
          this.EncrdecrService.setEncr(USER_NAME)
        ); //Session_UserName
        sessionStorage.setItem(
          'V8hpPfITcxhEI9x',
          this.EncrdecrService.setEncr(EMAIL_ID)
        ); //Session_UserEmail
        sessionStorage.setItem(
          'Xe003SRRyYEoOC2',
          this.EncrdecrService.setEncr(MOBILE)
        ); //Session_UserMobile
        if (
          RazorCustId !== null &&
          RazorCustId !== undefined &&
          RazorCustId !== 'null'
        ) {
          sessionStorage.setItem(
            'pOWgAF62qFXnZMn',
            this.EncrdecrService.setEncr(RazorCustId)
          ); //RazorCustId
        } else {
          sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
        }
        sessionStorage.setItem(
          'Hldq31TLYwRbLJ8',
          this.EncrdecrService.setEncr(SubBrokerCode)
        ); //Session_SubBrokerCode
        sessionStorage.setItem(
          'L2D3506kIHSk3E0',
          this.EncrdecrService.setEncr(USER_TYPE)
        ); //Session_UserType
        sessionStorage.setItem(
          'qAkZrQYLWNBSlki',
          this.EncrdecrService.setEncr(LOGIN_ID)
        ); //Session_CBId

        sessionStorage.setItem('pi4ZU2P3M8JE4q7', Companylogobase64); //Session_B64CompanyLogo

        //sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
        if (Family_ID != null && Family_ID != undefined) debugger;
        sessionStorage.setItem(
          'hn0bHyGhfpGtrPe',
          this.EncrdecrService.setEncr(Family_ID)
        ); //Session_Family_ID

        sessionStorage.setItem('Session_Exchange', Exchange);
        sessionStorage.setItem('Session_Cobranding', Cobranding); //added by adarsh
        sessionStorage.setItem('ihjt45h45=sb', SubBrokerCode); //added by adarsh for optimoney
        sessionStorage.setItem('ihjt45h45=p', SubBrokerCode); //added by adarsh for Optimoney

        //alert('Exchange = ' + res.Exchange);

        this.Loader.hide();
        sessionStorage.setItem('ShowHeader', 'true');
        switch (USER_TYPE) {
          case '2':
            this.Loader.hide();

            sessionStorage.setItem(
              'm5JkoXISmYRAIuY',
              this.EncrdecrService.setEncr(SubBrokerCode)
            ); //Session_UserId
            sessionStorage.setItem(
              'N1QJHdOkO7SBNAME8QC',
              this.EncrdecrService.setEncr(USER_NAME)
            ); //Session_SubbrokerName added by adarsh 27092023
            sessionStorage.setItem(
              'N1QJHdOkO7SBMb8QC',
              this.EncrdecrService.setEncr(MOBILE)
            ); //Session_SubbrokerMB added by adarsh 27092023

            if (RazorePaymentStatus) {
              this.router.navigate(['/dashboard'], {
                relativeTo: this.route
              });
            } else {
              // this.Loader.hide();
              //uncomment for payment
              sessionStorage.setItem(
                'nbj%98LS74nkjsn~@&4njrkd`!kd*294',
                RazorePaymentStatus
              );
              this.router.navigate(['/dashboard'], {
                relativeTo: this.route
              });

              // sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', 'res.RazorePaymentStatus')
              // this.router.navigate(['/dashboard'], { relativeTo: this.route });
            }
            break;
          case '3':
            this.Loader.hide();

            sessionStorage.setItem(
              'm5JkoXISmYRAIuY',
              this.EncrdecrService.setEncr(USER_ID)
            ); //Session_UserId
            sessionStorage.setItem(
              'UZT6qHaDZSz66kx',
              this.EncrdecrService.setEncr(LOGIN_ID)
            ); //Session_ClientBasicInfoId
            sessionStorage.setItem(
              'N1QJHdOkO7Hz8QC',
              this.EncrdecrService.setEncr(LOGIN_ID)
            ); //Session_ClientBasicInfoId
            sessionStorage.setItem(
              'N1QJHdOkO7SBNAME8QC',
              this.EncrdecrService.setEncr(SubbrokerName)
            ); //Session_SubbrokerName added by adarsh 27092023
            sessionStorage.setItem(
              'N1QJHdOkO7SBMb8QC',
              this.EncrdecrService.setEncr(SubbrokerMb)
            ); //Session_SubbrokerMB added by adarsh 27092023
            sessionStorage.setItem(
              'RelationShipId',
              this.EncrdecrService.setEncr(RelationShipId)
            ); //Session_SubbrokerMB added by adarsh 16112023
            this.router.navigate(['/client-dashboard'], {
              relativeTo: this.route
            });
            break;
        }
      } else {
        debugger;
        this.router.navigate(['/login/investor'], { relativeTo: this.route });
      }
    } else {
      debugger;
      this.router.navigate(['/login/investor'], { relativeTo: this.route });
    }
  }

  CallAlertModal(msg: any) {
    $('#AlertModal_Family').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent_Family').text(msg);
  }
  querystring(Encrquerystring: any) {
    let string_resp = '';
    let string_resp2 = '';
    if (!environment.production) {
      //   const resp ={
      //     "Family_ID": 124,
      //     "Exchange": "BSE",
      //     "RazorePaymentStatus": false,
      //     "RazorCustId": "0",
      //     "Companylogobase64": "C:\\UAT\\All Publish\\IFA_Onboarding\\Images\\CompanyLogo\\732560.png",
      //     "Cobranding": "Y",
      //     "SubbrokerName": "NewGoDigital ",
      //     "SubbrokerMb": "9699525939",
      //     "DOE": "",
      //     "FIFO": "n",
      //     "SWPFlag": "1",
      //     "STPFlag": "1",
      //     "SwitchFlag": "1",
      //     "RedeemFlag": "1",
      //     "RelationShipId": "1009",
      //     "USER_ID": "AESPV4229G",
      //     "USER_NAME": "AMITA VERMA ",
      //     "USER_TYPE": "3",
      //     "TOKEN_ID": "ADmwTfxD3EgAMPg4QQCxQpsTMKvuknwm",
      //     "PWD": "",
      //     "ROLEID": "0",
      //     "LOGIN_ID": "1081066",
      //     "MOBILE": "9619724883",
      //     "EMAIL_ID": "adarsh.u@optimumfintech.co.in",
      //     "APP_PIN": "",
      //     "APP_PINFlag": "N",
      //     "SubBrokerCode": "732560",
      //     "EmployeeCode": "0",
      //     "ARNStatus": "1",
      //     "Segment": "",
      //     "EUIN": null,
      //     "EUINNO": "",
      //     "EUIN_OPT": null,
      //     "result": null,
      //     "CreatedDate": null,
      //     "IsPwdChange": null,
      //     "CurrentStatus": null,
      //     "IPAddress": null,
      //     "Message": "J4JleZ6Z31Z6HGAX7EAjPw==",
      //     "code": 0,
      //     "data": null,
      //     "merchant": null,
      //     "LoginTime": null,
      //     "EncryptedData": null,
      //     "LoginSource": null,
      //     "hdValue": {},
      //     "CustomerId": null,
      //     "BirthDate": null,
      //     "RiskProfileStatus": null,
      //     "RiskProfile": null,
      //     "RiskProfileLevel": null,
      //     "RiskProfileInsertedDate": null,
      //     "KYC_Status": 0,
      //     "KYC_UTIURL": null,
      //     "Status": "vkVI5hKwwvkP0wBzxLPn5g==",
      //     "ID": 0,
      //     "MpinStatus": null
      // }

      // // let string_resp = TOKEN_ID +"|"+LOGIN_ID+"|"+USER_TYPE+"|"+USER_NAME+"|"+EMAIL_ID +"|"+MOBILE +"|"+USER_ID+"|"+Family_ID+"|"+FIFO+"|"+DOE+"|"+SWPFlag+"|"+STPFlag+"|"+SwitchFlag+"|"+RedeemFlag+"|"+SubBrokerCode+"|"+RazorCustId+"|"+Companylogobase64+"|"+RazorePaymentStatus+"|"+SubbrokerName+"|"+SubbrokerMb+"|"+Cobranding+"|"+Exchange+"|"+RelationShipId

      const resp = {
        Cobranding: 'Y',
        SubbrokerName: '',
        SubbrokerMb: '',
        DOE: 'Y',
        FIFO: 'N',
        SWPFlag: '',
        STPFlag: '',
        SwitchFlag: '',
        RedeemFlag: '',
        RelationShipId: '',
        USER_ID: 'ARN-151867',
        USER_NAME: 'UAT ',
        USER_TYPE: '2',
        TOKEN_ID:
          'TnCXtc+jFsDVur8kt0SCc+0UJcYfiMRUnCeSY2oHp169FaUigYM9r7EH3WFPGL_x-qr94tf5kWwckBMWgd6QMdQ==-kQDQj2YgYgtbpfsBvfuL/w==',
        PWD: '',
        ROLEID: '0',
        LOGIN_ID: '732560',
        MOBILE: '9699525939',
        EMAIL_ID: 'adarsh.u@optimumfintech.co.in',
        APP_PIN: '0',
        APP_PINFlag: 'Y',
        SubBrokerCode: '732560',
        EmployeeCode: '',
        ARNStatus: '1',
        Segment: '',
        EUINNO: '',
        CreatedDate: null,
        IsPwdChange: null,
        CurrentStatus: null,
        RazorePaymentStatus: false,
        RazorCustId: null,
        Companylogobase64:
          'data:image/png;base64,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',
        Family_ID: 0,
        Exchange: 'BSE',
        Message: null,
        AppName: 'NewGoDigital',
        RegNo: 'ARN-151867',
        FromDate: '04/12/2024',
        ToDate: '18/11/2027',
        UploadedQR:
          'iVBORw0KGgoAAAANSUhEUgAAAL0AAAC9CAIAAABptetnAAAABmJLR0QA/wD/AP+gvaeTAAADt0lEQVR4nO3dQW7jNgBA0brIMbJI7n+obHyMAOl2Fiwqf4aUVLy3NBJHY3xwQFOkHj8/P3/Bi/4++wK4Jd1Q6IZCNxS6odANxdvw1cfjsfk6/tPw+4Lj1zn56ytc8JKGhtdpvKHQDYVuKHRDoRsK3VCM5+FD21bOV8xFJ9/z3LsGLvjJG28odEOhGwrdUOiGQjcUL8zDhy44v73gyvmKf+a5l2S8odANhW4odEOhGwrdUMzOw+9ixeR8aPiewxdvvTPfeEOhGwrdUOiGQjcUuqH4H87DV0x6V8zYb814Q6EbCt1Q6IZCNxS6oZidh99l4/SKPefb1thX/Pok4w2Fbih0Q6EbCt1Q6IbihXn4BY/ynlz6Pj6RXvGTx13wkzfeUOiGQjcUuqHQDYVuKB63vo96ch5+wdPX7sJ4Q6EbCt1Q6IZCNxS6oZhdD9+2UDw5u77gieXHnfukcc8P59fohkI3FLqh0A2FbijG6+HbdlNPuuAN25NfTExa8V3JkPGGQjcUuqHQDYVuKHRDMV4PX7H4vO0m8HMvfsVXA+ceMmc9nF+jGwrdUOiGQjcUuqF4YX/4rXdT3+Xi73KdxhsK3VDohkI3FLqh0A3FvueWWTnPf/2C12m8odANhW4odEOhGwrdUMzOw4e2TaTPPeZt8icveJ6c/eGspRsK3VDohkI3FLqhmJ2Hb9tiPXzPbcvp5x5ct+IDsT+cE+iGQjcUuqHQDYVuKJbsD9/2jLFtx4Mf/+tDF1zldl46J9ANhW4odEOhGwrdUIzXw7fN8e7ylK/jLvis7xV/3XhDoRsK3VDohkI3FLqheGE9/IK2LdEff89ti+TbbiUYMt5Q6IZCNxS6odANhW4oZtfDtzm+nD40Oe1cse966Pv7+/l8/vnK+/v729vRbfyTdyIct+R8P7Ln8/n5+fnnK19fXx8fHyddzr/y/xSFbih0Q6EbivG65l3mU8dtO8168iePz6dO3mV87p3hQ+c+4ezce8iPW7EePuScNn6Nbih0Q6EbCt1Q6IZiyXnpx63YjL3Cihn7ign/ti9QjDcUuqHQDYVuKHRDoRuKe99fvOJOhm27vs99UPkk4w2Fbih0Q6EbCt1Q6Ibi3vPwyQ3eQ9uecLZtz/nQ5Hsabyh0Q6EbCt1Q6IZCNxSz8/Bzj1vfdlf85Hr4uZ+S+9K5Ct1Q6IZCNxS6odANxQvz8Fsf+jd5w/bkTeC3/rZiyHhDoRsK3VDohkI3FLqhuPfzwzmL8YZCNxS6odANhW4odEPxD+Cfw4IySgwuAAAAAElFTkSuQmCC'
      };

      const resp2 = {
        Cobranding: 'Y',
        SubbrokerName: 'UAT ',
        SubbrokerMb: '9699525939',
        DOE: '',
        FIFO: 'N',
        SWPFlag: '1',
        STPFlag: '1',
        SwitchFlag: '1',
        RedeemFlag: '1',
        RelationShipId: '1009',
        USER_ID: 'ADFGP7896B',
        USER_NAME: 'Anuradha Chauhan ',
        USER_TYPE: '3',
        TOKEN_ID:
          'rwCEgftOgB03o2a8WcDOA+fOqBEY1KuYjDJgCMukg4FctV2Os1GMvTa3o+APKSoD-+L8D7giibfS0SG4p23aRcA==-sa1p7Jj0PmuWl0iaaKqa6g==',
        PWD: '',
        ROLEID: '0',
        LOGIN_ID: '1081177',
        MOBILE: '8796424947',
        EMAIL_ID: 'adarsh.u@optimumfintech.co.in',
        APP_PIN: '1234',
        APP_PINFlag: 'Y',
        SubBrokerCode: '732560',
        EmployeeCode: '0',
        ARNStatus: '1',
        Segment: '',
        EUINNO: '',
        CreatedDate: null,
        IsPwdChange: null,
        CurrentStatus: null,
        RazorePaymentStatus: false,
        RazorCustId: '0',
        Companylogobase64:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAABBCAYAAAAdf3znAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxEAAAsRAX9kX5EAAB5JSURBVHhe7V0HfBXF9v5uSW5ueg+BBBKCgdB7F5UAIuJDEOyKKAgIogIC+mz49KEg6BOeT6UqKIr8pYggSi8CofcaCQFCer3J7Xf/58zdkLYpJEFR8/Ebszs7O7s7880535mZRJVEQB1qDVcMyRj58z9xIfsSdBpXOffWhET/LHYrJnZ4GnVEqGUsOfk9Ju14D6EeQeCmzbcWwCE3sYeLHlaHTRzrtW7imovaha47RHKn60abSVx30+pEnsFSIAil07rC7nDQdSPV4w47XTPZzPCkY7qb6jI669Dq4aLRooDObQ67qEtPdQEqFNC9KvrHdbvSc5kIhWSoI0It48tTqzBt12z46rxEo7cNikGIRyC0Kg22X9mPAL0vzHaLsBidQlohOT+NOllHHarH8fRzaOYfRXcB57MToFVr0TW0LS7mXMHlvGvwcfVEtF8k9qccR6DeDxHeDXAk7YzoyL6NesBP542fEnYg12IQz23oXV+Q6GDKSRis+egQ0lIQYM+1w0gtyBCkKSSD2vn6dagtcOcz2ApoVGrM7DUFPeq3R4RPAxrFdjwe8w8su+cD6jwLmeQRaB/cAgMi78DIlg/hIhHhoegBGN58MBEkXXT6on4z8GL7p5BpyoE3kWv5vR9iYOO7EKT3x797TkSuOQ/TOj9LZYajT6Puom4e21M6jcKQJv0Q5lmPrI4GseHd8Ha3F3BHWCcspTJRvg1hspvFu/I71xHhpkIlzHdi7jWcyfwNacZMYZ6D3QNER2WZcgU58iz5aOwbjkldx6NF4G1iRLPVGNykL9bGb0YDzxAx+tmtZJlz8FL7EWgeEIW0gizU9wzG/VF9MH7zdDyxYTI+Ofq1cDE2KpuUn0qW5RJZk2R4uLojLuUYBq8ejVMZFwTZ2J0Uoo4INxVOr+ut8yBX4U2NrSIX4IHFJ1aiZUA0ejboQCbb6dtdNS7kNvzgRqacfbsPjf7Yht1EfmOfcHSr3w5WcgGXcpPwBbmfN7tNENpARVaHwcTh+65R57N+4Cd7kOn3d/MmF6MRVoL/gcpwWXY7he/HqCPCTQaLOfbL7iQO/dx8xE8TdcT0vXNFZ3MnsW8/l3kRr26ZjkOpp4RmiA3vTqTQYeX5jdh6eS8ebTpQlA31CMay06ux6+oBNPFtJLTDFro+t/cb+LzvO5jRc5IgDAtEFoXc4awnuPM7BrfEkoEfoUu9NlTHGqERCqF5iyAf16EWcDTtNDYl7hEdweMtIffq9ZHLoi8+J1H8PJFxjsThWXGdO/McicNc6iwDuYmTGedFZ269so9cwxZRNoe0QCKXy7qIy+RqdiYdxOnMeCE2t17eJ6wKRxwz9n9GrsaA5IJ0YfrZolwxpOAs3ccC0UCRykeHvhD1sAthsKWoixpqGRw+vrj93wgmMcdNm0dqnTuJ4UVuweKwimMejawF2BXwdRslL/Lj3Hks3lQqldAEhfeYqJO54/g659kkm9AfXhRJ8P2sM1igcojKkQJHCYWhKj+LqkO+hTQB/dSTpWGrI5wFuwxKdUSoZfBof27LW8gwZsl++NYGk+kximRuiAjMOA6OmK23HJQ+g/P4XX/n9+UmzbHkQS0LuVsT1CaubvRfNcSMR0VESEzKwLa9p3HgeAIuXU1HrsFIH6eCn48HohqFoGu7KNzRuRn8fT3kO/445I6dAOuxE1Dp3eQcGRoN1IEB0DaNhkuPbnClpHIrVebvivO/kUkww84aRokIV65l4sPFG7Fu82Ekp+WIPLWa2c1FnaPL4XBQngoRYUF4dFA3jH20Nzw9/rgGzux3H6x746DydAes5Ievf5bzfSW7HSpXF2ibNYP+meHQP/mYyFcEfZtp5fdwpKbD7eFhgki1CclogumbFQC9k9sjD0Ll8fsPJKmgAFn9/wHbhXgxMMoQYfUvh/DPWd8h8VoGPPQ6mC02YQW8vfTwoo5m95CbZ0RePlkHIodWo0aB0YJ2LRrhw9ceRYdWkXJNvy+y/jEU1rgD1KjuRAZPqLRaYaKZFFJODqT8AsDF6bMlswW6vrHwmvM+NGENRF5x5M/+CIbX34ZEhHAbcDd8vvqirKWpLuid8ia/goL/fipO3Z4eDp95H/JIE+e/FwQR7r4PtvMXyhLhk2Wb8drsldReGtjsDkGEu3u1EqlldAPhEhwOCelZBhw+mYAfNh/B9rgzYsxxeU93Hea89hge6N/RWWEVYDTbcfx8EuITUpGdZyBiaRAW6o82zcJQP8hbLlU5BBH27IPK1we+Xy2GJqoxixrqdDMcKamw7ouDae2PsB08DOhIMVNDaJs0hs8XC6GNaSrX4kTWwCGw/roXKi9PSFYbAvZsg6ZRQ/lqzSBZLMjs2Rv2xMui89UBAQjYu0MQWMrLE9aCG1Tl40MW7OatXgoi3DOorEVYuSEOo6Ytgjt1fr7RjB4db8P0F4egYyUjfMP2Y3jzw+9x9mIyTCYLxj3ZB7NffaRSQZllMGPt1lPYfywBdpsV7m5aYW3S0rNxNj4JmdkGoUGeH94XXdtUbmWuE8HPBwGb1kPdUKHjbDYYl34Nw4xZ1OgGOrdC0yQKfmtWQh0cJBcici5cglwataBOY9fg/b+Pa7VTDO+8h/z3Zwvr4P7CeHi98yb1vIqs0HSYvl0pCOL9v7lwvauXfEftozQR2HxK5y4mS43vmCSFdBov+bQeLY1+dZFEncqXqoRrqdlS/6dmSe/MW0PWVM6sAIfPpUozFu+Slv14REpMzpVzi2A026T1209IvR+bKeljRkpTZ34nmSw2+aoyMu97QEoJDJNSb2sh2c6fl3OVYTl0REpr20VKCY2Qkn3rSdkjx8pXimDeuVsyrflBchhNck7twvTzZsm04WepeIPlPv+SlOwZKCV7hziv3UQ48vOljF59pJT6kVJq4xgxmSCNmrZQ8mr1rOTfdqz0j1EfkjW0i8I3gqrec/hCpvTFhtNSUnq+nONEXr5ZImEqZeaUzJ85f4OERo9LQ56bK2VkGeTcsrgRIjAscQek1IimUmpYlJQS0IA6ZpN85Y9D7ksv07vUF99h3r1Hzr05KE0EzdPPPv/WKyQOWfSx6v9y9mgE+XvJBqTq4AiiMlxKNSIxzYh7uoTDz4s3WkjYuu8CFny3G8vW7MGK9fuxcMV2fLn6V6Sm5yKmSX306d4cwUF+mP3xatxG5+1bRsi1lYRp+Qo4rlwVok7/2MNQ+/vLV5ShaVBfCEnL1u3CLEu5uXAbOlhcc2TnwHbiFBxJSSx+oCZ/XR7sl6/AunO3SLYjR+FIThFRgNqr/Dbke+znzsNxLZneV39diFo2/gLb0eOkIHUi7LXT91jjDsJ6gNKhI9BEREDlXrQ+UAjWHax9rNt3CvfIdXOeOigQKqpHEfTtpq++gSMzSwhrbnjJq+WzwiVMevdrmS+1jwIy95uOpEnZ+VZxnpFjlBasOiB9+OV2aceBeOlqao6UkpEnHTqZKL09b61Ur/MEKaLXJGndliOi/C+7T0pJKVniWAk3ahEY9ozM6y4iNaq5RP5S5Js2bJRS/OqRiQ6Wcqf+U+SVhvXMWSln7PNSWtPWUkpQmHAxnFKCwqW0mLZSzguTJdvFBLl0SeS98oaU7BUkpfiHSqa16+TcQovQQLxLSnBDZ538HlQ2mSyF9cRJuWQRCr5YJmXc2U9KadBYSqb6kn1DxM8UsnQZvftLxq+/lUuWRGmLoN6x7wxcXDRwpXRv77YyXWofF5MLEOKrg4+7Fjn5Fuw4fBntmjXAi0/0wu0dGosIIdjfE+2ah+P1cfdh98rX6dwb942cg2NnLgvLEBrsK9dWO1D7+8G1Vw8xeqTsbFg5oigEh3OcFESvee06ZN33AIzLv4ODLAnPO6ioLCc+ZotiXLJURB+WTVvku4qB6yysvzxQGVGnyllv4XJzISSDATnPjEHuhEmwnT5DI5zXFfgetgBUP414tmo5z72AnNHPkzgs2nugBO2xs1dEuOhPoWFMFJnLSrBxx3FsI/K4u1Wsoi30YlENg/HU0Ns5iqMowYZ2Uc5w8OCZFDRtFICYCKf5Ts/Kw8HjCSB9IN6hbfOGaBweiFWfTsAychOlCUCElo8I3GDyYXXg0raNMJEShb+2+N+cmdzo3En8mFJEMP+ymRp2vCjDE1Qqb2/oYu+CtkWMIIHt+EmYt2ylYzscGZnIfno0fL9dBtduXeQaCMWJUKp+figpdegff0SEtTwRxvWCOlhdr56zCEU/PJPK4bDKh9qUQk6XDu3g0rM7NPVCYCeXY9mxS7gqDoFNy78lf2SDz+f/LZd82gzqBIavjztpBN7kWDG27DmFmfPWwtvPU84pCw4d8/JNiKVRzEQwGO1kcVRw12mQlG4QmyAKSXDhUirijsbj9IUk7Nx/FrsPnseLI+7GrFceRv0QX0wZPUCU487nZKeGYTmiYb9GjWYmH+5SzsdVBeqQYNGpUFP9Oc5Z1PKYxR1rePUN5wmFnq49e8Dz39OhbVZyHsJ29BjI/JNvPyQIYZj2Ovx+XAWVZxVnEHnCa/AguPboKmeURMGCxUSCdbJ2UcHj3bfgPuJJYrWLswCB50+MC5bA8N4sqH19YPrue7je3gP64Y/LJUpC7Zw6ZtJxQ4vDCsGzjCxkNCQuSyeeDNKTpeCJJ07enk5hY7La4enmnNW7mpaPRqFOy0A+HwlX0jDgzjb418QH8MvSqZg2ZmAJscqdz9PZJOfoZVVicjA1PQurN8Zh5qfrYMg3ikFVTt9VDrIE11HK/JaG6etvYDt3QRxr27WBz9KFZUjA0LZpDZ9li6FpeptoKysRw/T9avlqFUAfJOXnyyclwWTleQ4WpNzZnkyCZ58pQQKGSqeD+7jR8HzjVWFhWGQWfLbAOX+iAHW9IB/R2JnZ+cjOVX54cTw4sAuWfjQan747okz6fMYIPPvInTARo200UpkMDI4OdC6FhHPA39upkhOTMtGqaTh8vd3FObsoJsSU0feKcwZbFyZremY2ftx8EC9M/xpPTF5IaZF4jj9ZMt7mXV0m2K9edZpeekd1oBxpKI0IKmP+eTM1sNMlek6dXOEaAesPz4kvCDOuIvaa12+Ur9QMlj1xsCckCgLzIpr+iUflK8pwH/U0XDp1FN9kv/AbrPsPyFdKQt2+RSPSGXZkZBtw9PRlObt8tGveCI/f3wMPDuhcJj3QvxOCA3zE2gPPEkZHOn2aitq1sG05TNWRMGWi6HRaKl9+mJWVnYufth3G5He/Qt/hc/DUlMU4fCoBaRl5aBcThlEP9hBrIYIFVbBmShDmm8jGIZQ2OlrOLQtHRgZ1wCVRVhMZAZeuneUr5cOlV0+oQ6kNiMj2hIRyR+ONwHbqNCQiF7smXb8+cm7FcO0XC4nXXFhAsrAUKDly1Hd1jaFOcUCiEbFqozJbqgrulG/X7YXOVQs3Sj06kGkkuJI1sNAzCmETboisBJUpORUtIScvH5t2HceUGcvRf8QcPDZxPuYs2iSYNHJoZ3iRjrmUlIWRw7oJgUtVOd1VNcDz/Rz/0wuKmFvbsZ18pSx40YpNMVsGXh9QuTutWEVQeXlB7ecn3l0ymSEZC+Qr1QfPdwiRxJayUDxWAk19OQig+6RcpyYsDfVd3ZqjHoVurtQp67cdxa4D5+RLN47F3+3ACYpCuHNaNQtHx9bONQIvPflJmQgeehfkGMzk0nh1kC2n87dxGNv3nkHPYe9i6Lj/4vNvtuNMfDKRxQUTHu+OZ4d1wq5DCdi8N55CyWj079WchKJE7sRJpuoYhIKP5sGeniE6yZVGryY0VL5SFuxjxXoDjW5HVhZ1asXhmAB/IGuw6rxcOeAoQDQw1e1IS5NzK0HxgVLOoFEHkPofdm8XGApMpMglTP73cvLHyqypCIdPXsJ7n62DXu8KC1mGUQ/dRQPNKRBdtGq4UcSQZbAiPNgTaVnORmRReCU5SxyTSUKHVg3xzLAe8PHSC13QplkoPpw6ANERgZjzxW6cik9FkJ8Hnn6gC4lSN2i1NJJJjJW0KlWD6fs1MJL4U9PI5k7Ws+CqAGwFNA3DRafaf0uA9eAR+UoFECS4ARYUL8v3KkBL4lTMFmq0sGymMLUqqMI7iKdxuMbxO/v1cxeT8fjET8XupKpi35F4DJ/8udAG+QVm3Nu7DZGrk3zViQb+bkjKMJFFcBUrjVfTDKQPvAVxrqVmI5fCTXZPox/uiTfH34PBfVrg41cG4ujZa5j+yRYUmMjH0fvde0cMurSJhF2iKIWsgXJzVQxW8HkTp5KIcxETQu4jR8ClfSWTadT4rrF3QbKwe7Ajf+ZsMRFVHoQrMJAmKKdDFaHXizbg+lGg7EZcunaBOjyMxRYs23fC9H8VRyOSgQKAKowT8ZY8MudOf5JGrYtQ7vuPXhQzest/2CsmhsoDTwDNWfgTho2fh5T0HNIvdtwWESKWoTWlGsDDTQMvdy2upJsQ3dAP2eQekjPyEUJkYEJwaMgdbTRb0SwyGJFh/nhv4U588k2c0BLM6pAATzx5fyeyAi7kylypb8gayPWXQDkjgOf48155HbnjXoRkt8FB4k3Xpzc8XnlZLlExeJJHw8vb9G3WPXuRO3IsHFeT5KtF4M0eueNfgJSZyeZQzq0c2iZN6N3JhdJ3mVavlXNLQh3gL3ZXcQezwM17+RWYvvlOvloSBR/Nhenb78RGncpw/S27to3CwveewdjXliA7r4A6Nhfj3/gS87/Zht7dYkS04E9uxEFhSzJ1+v5jF7F590lcuJQi5g6MJgua39YAS2aNQv0QEkgKaBikR/w1qjvbghaRAbiUnIuEa7kk+tzgTh1ro4hCTBa56IgQrCd0RHxS9GT6C4ggI4d1RtPG5MfVGqc1KG+08UhPSYXtYoLYUyAWb/bug2XrDtivXYOaRh5bAl2fWHjP/0TE3FUBTz55/esN5Ix8TmxuMf/0M6zHT0B3dz9oW/LMogTbsRNiskfMOt7gFjTX2DsphA0U+sO88RdkP/E01d0XKm8vqk9HxxQlUFu4jx0F6+5fYd60RQjS3BdfhnGlc8KIdY49KUnMLHLI6jN3jnAjlaFECd6JtPrzFzHlvW/w68HzNOpccPzMZRw6kSAmjNzonN2HmTqFf7IG4E4yktkeek8nzJjyEEICK95VFBXqjstpJmEZwoK9hFg00P05ZE1Y8kmSCpHhwXhpRG8U5OfDardjxfqjaBsTimH921IJDVkIndMalKMNVJ5eMK1YKUa/GA2s9hlENhHKkvL3mDAOHq9NqzIJCqEbdB+8yGzzbCFP/zLhjPMXyVcJ9EpsjzQcNvL08A3oF94F5THpBeRN+acQhZafN8GyYaMIF8VOpj3bxQYa3kjCBM4dM0GQkSMY647dguj8NH6+iiw7P1tMUXNGoZUsx1qWGVKtSe3/MH+i2HLWulkYkYlUMt1sowpZUBbQyOcJHDbj7Eru6NIMS+eMxqKZoyolQSHCg9woktAiKdOMPBN1ipuOBCJ9nKeb2O7mRh9qJ45qXfWYNjIW3ds1wiP3tkeDehTiubjSgCeRWMoacFjFU8Cs6PljxRY1CpV4Vo39Ln8/jx7d/ffB7/+Ww/Nfb5ZLAvb9oi4y7WKvYynoH3kIvqu+he6eu0WnUO2CXCLRc9Re3tD17SO2m/EytgBfKOwLqtORRfXTM0rrDPcxo+D1wXsQy+hEAK6TF53sV66QQD0kl6JnUFjq+9USsbtJ04hELJtS8XyeHKNEJHBp2UKspXDYKsJfTlbnL9iINsrJEd8olqKpQ5UpQuDReoCswRGKCOITUynGLxCjMJBcRHRkKDq2ikCLaBIuNQDvWbRStMLgwcOMVoEb1UoD2QSHzQpeD3HTucKbRokbmXUddSBbhOIw/7BeLLaoyE25PTgUlk1bYVz+rWgwHkVaUtsunTtCE9FIvqN82C8lwkyjkU29tlULuHZXnvNn2M6eg+3wUdiTk+lMRTF7KLTt24n9kLxJNvOOvhRlXCSB1wD+P68TI5v3DFiPHafOUwuNwhNUpcGhoYVGuZ30Bm8rY3fnNngQuaDmcoki8EQVzxjytjM+ZiuojW4ivpfdE2sj22FnlKOJjqa2iBYkM635QayUchRSIRH+KDCr7bwaSC9roRHDZOe35IUmtgasD6oTMv7esJ04KZai2edrW7eC/4Y15IyrLh5/T5Sjtv5Y8No7dza7CG9vb7h7eMKTzLo7+UImwp+BBIyCBUvIHOcL8+/ahcLpW5QEDJXVar3lLMKtBiZlaXDnWvftF0pdCQWfLYThzbfFXIVExGVroG3hNOts6W41qCIjI+uIUAkeeughzJgxQz4jEpDo4ojEuOxrsfrHmkQbFekMH8+dF/sn2f+yGGXx6jntZXi8OkXcO3z4cOzcuVMc32pgItSlChK5I+ns2bMspwTyP50vXYNe7PdLCWwgpTSIktLadJbSWneS88Kcewi9gqScsRMkUurivm3btinWfyskdrZ8UG2wei8TypGyq6r5UxJ+vGeBdyL9HmDNoQRymfKREx06dMCOHTuETpFolOfP/Z/Yl3h9F7D4BPoPh2X07Ryp8IYRnhegD0QyRRVdu3bFpUuXxPcquZua4EbaXAk1JsKECRMwceJE+cyJ+Ph4xMbGymcVY/Xq1WjbtuQ8//z58/Huu+/KZzcPU6dOxdixY+Wzkjh8+DAGD3Zuby/EnXfeiRUrViAoyPlbUTyVbF6zTmw3523s3OG8/8C1S2foBg28Hqpye9x///04ceKEOA8NDcXWrVuFGK4tHDp0CEOGDJHPqocSJuJG09tvvy3MXnFcvHhRsaxSOnLEuV29OP7zn/8olq3N5OnpKaWnp8tPVEb37t3L3BcRESERGeQSFcNCLuGzzz6TAgICStQRHh4ul6g9HDx4sMQzbjTVOHwsbUIZJpPzr4dWBebC6d9iUKqztvHEE0+AOkg+U8akSZPkoyIkJCTgwQcfRKdOnTBz5kzsi4tDWkYGTDYrTPTeySkp2LVrF6ZPn442rVtj9OjRyKDrxXEzwl+9vuwvvtwIauwaXn/9dZBVkM+cOHPmDGJiYuSzirFv3z507lxy29fs2bMxefJk+az2wbrm5MmTaNq07MbT4mCdwt9x/vx5OUcZPj4+8PLyEn46JycHBl5+rgBcdsyYMYo6gfVR8+bN8eSTT8o5TvCA+eCDD0TdSkS6evUqvvzyS/mseihjJm4kERGctqkYTp8+rVhWKRER5LuKQB+sWLa20qBBg+QnFYFGrXBppTF37lzFOm5muv322+WnFyE7O1siUa5YvjbSLTmzeLOhZPIXL16sKBw57g8MDJTPfh+whSkNtgKVubKa4G9HhC5duoBGnHxWhKVLl+Knn35CEv/iazGwGR85cqR89tfF344IStbg119/xdGjR8XxokXF9hbIeO6558SK518ZfysiREVFlZkbYMybN08+AhYsWCBWPIuDwj0xzfxXxt+KCM8//3wZpc5qe9WqVfIZxMzf2rVl9wu+9NJL8tFfE38bIvj7++Opp56Sz4pAUUGZeQ+eHyChLp85wbOfffpU7TeL/oy4KUQo3YgV4UbK1gQs+EqrcY7NWR9ERkaWSOnp6Th79qxcqgg3c27jj0aNiaC0k7jc3cUKqOn9VQELvXHjxslnReAFp40bN+LcuXMlEk+INW7cWC5VhH79+qFVq1by2V8LNW7xfIVf3w4LC0NISIh8Vj44NFNqcKU6a4KhQ4eiocKf22PC8dQs64biiX9nglNpcCz/V9UKNSZCXFycfFQEDw8PMR1aGd5//33FSRKlOmuC0qujhajILZV37eGHH0b9wl8q/YuBv7jaSaPRiJUvJaxbt05Ml9Kou16ezLTUtWtXaeXKlXKpkuANIFym+DNqknr37i3XXBJTp06VmjVrVmEiVyDZbGX/vuM777yj+KzaSgMHDpSfVIScnBwpKChIsXwtJcXMG0pt2rSRDIby/wZiYmKitGfPHomEmeJ8fiFIvEndunVTfEZ10/r16+Xai5CSklJlsv3444/yXUXg+3kZW6l8baQ/LRE48dp9fLzzz9NVB0yW2NhYxbqrm1q2bCk5FP4ULLkkxfJKqX///vJdJTFmzBjF8rWR/tRE4OTr6ys2qnCnVhVJSUmiYwIDAxXrrG4iYSetWbNGfkpJREVFKd6jlEhQKhKcN7WQ2FW8p6ZpyJAh8lNKggS4YvnaSDXej6AEMptiYYfMPMjXiq1ZHCEweD2dTKsI0chdiB29vIZf2+CQkf+/ZWKPoSz8OEq4cOECPv74Y3FeVQwYMABkGcRegUJwVDFr1iyQq5Nzag8tWrQQG1oKn8fRitFoBGmTSvc6VBc3hQh1+POhdmdu6vCnRR0R6iBQR4Q6EID/B/AM8YLqkDmWAAAAAElFTkSuQmCC',
        Family_ID: 141,
        Exchange: 'BSE',
        Message: null,
        AppName: 'NewGoDigital',
        RegNo: 'ARN-151867',
        FromDate: '04/12/2024',
        ToDate: '18/11/2027',
        UploadedQR: null
      };

      string_resp =
        resp.TOKEN_ID +
        '|' +
        resp.LOGIN_ID +
        '|' +
        resp.USER_TYPE +
        '|' +
        resp.USER_NAME +
        '|' +
        resp.EMAIL_ID +
        '|' +
        resp.MOBILE +
        '|' +
        resp.USER_ID +
        '|' +
        resp.Family_ID +
        '|' +
        resp.FIFO +
        '|' +
        resp.DOE +
        '|' +
        resp.SWPFlag +
        '|' +
        resp.STPFlag +
        '|' +
        resp.SwitchFlag +
        '|' +
        resp.RedeemFlag +
        '|' +
        resp.SubBrokerCode +
        '|' +
        resp.RazorCustId +
        '|' +
        resp.Companylogobase64 +
        '|' +
        resp.RazorePaymentStatus +
        '|' +
        resp.SubbrokerName +
        '|' +
        resp.SubbrokerMb +
        '|' +
        resp.Cobranding +
        '|' +
        resp.Exchange +
        '|' +
        resp.RelationShipId;
      string_resp = this.EncrdecrService.setEncr(string_resp);

      string_resp2 =
        resp2.TOKEN_ID +
        '|' +
        resp2.LOGIN_ID +
        '|' +
        resp2.USER_TYPE +
        '|' +
        resp2.USER_NAME +
        '|' +
        resp2.EMAIL_ID +
        '|' +
        resp2.MOBILE +
        '|' +
        resp2.USER_ID +
        '|' +
        resp2.Family_ID +
        '|' +
        resp2.FIFO +
        '|' +
        resp2.DOE +
        '|' +
        resp2.SWPFlag +
        '|' +
        resp2.STPFlag +
        '|' +
        resp2.SwitchFlag +
        '|' +
        resp2.RedeemFlag +
        '|' +
        resp2.SubBrokerCode +
        '|' +
        resp2.RazorCustId +
        '|' +
        resp2.Companylogobase64 +
        '|' +
        resp2.RazorePaymentStatus +
        '|' +
        resp2.SubbrokerName +
        '|' +
        resp2.SubbrokerMb +
        '|' +
        resp2.Cobranding +
        '|' +
        resp2.Exchange +
        '|' +
        resp2.RelationShipId;
      string_resp2 = this.EncrdecrService.setEncr(string_resp2);
    } else {
      string_resp = Encrquerystring;
    }
    let url_string = window.location.host;
    let URL = 'http://' + url_string + '/MpinLogin?data=' + string_resp;
    console.log('MPINurl :' + URL);

    let URL2 = 'http://' + url_string + '/MpinLogin?data=' + string_resp2;
    //window.open(URL2);
    console.log('MPINurl :' + URL2);
  }
}
